import { gql } from '@apollo/client';

export const DELETE_EXCHANGE_RATE = gql`
  mutation deleteExchangeRate($input: DeleteExchangeRateInput) {
    deleteExchangeRate(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const IMPORT_EXCHANMGE_RATE_VALUES = gql`
  mutation importExchangeRateValues {
    importExchangeRateValues {
      commandId
      correlationId
    }
  }
`;